import React, { useState, useEffect, useMemo, useRef } from "react";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button, Spinner } from "reactstrap";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../../Constants";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { Container, Row, Col, Card } from "react-bootstrap"; // Material-UI can also be used here
import { Loader } from "react-overlay-loader";
import 'react-overlay-loader/styles.css';
import { Fab } from "react-tiny-fab"; // Corrected import
import 'react-tiny-fab/dist/styles.css';

const CompletedPayroll = (props) => {
  const history = useHistory();
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [status, setstatus] = useState("");
  const [saveStatus, setSavestatus] = useState(null);
  const [payroll_tracks, setpayroll_tracks] = useState([]);
  const [selected_track_id, setSelected_track_id] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [selected_payroll, setselected_payroll] = useState(null);

  const defaultColDef = useMemo(() => ({
    editable: false,
    sortable: true,
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
  }), []);

  useEffect(() => {
    listTracks();
  }, []);

  const listPayrollDetails = () => {
    setIsLoading(true);
    genericPost(ENDPOINTS.LIST_TRACK_PAYROLL_DETAILS, {
      track_id: selected_track_id,
      status: status
    })
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200 && res.data.status === SUCCESS_RESULT) {
          setRowData(res.data.data);
        } else {
          cogoToast.error(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
      });
  };

  const listTracks = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.LIST_COMPLETED_TRACKS, {})
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200 && res.data.status === SUCCESS_RESULT) {
          setpayroll_tracks(res.data.data);
        } else {
          cogoToast.error(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
      });
  };

  const savePayroll = (e) => {
    setIsLoading(true);
    e?.preventDefault();
    let _employees = [];

    gridRef?.current?.api?.getSelectedRows().forEach((element) => {
      _employees.push(element.id);
    });

    const data = {
      track_id: selected_track_id,
      status: saveStatus,
      employees: _employees,
    };

    genericPost(ENDPOINTS.SAVE_PAYROLL, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === 200 && response.data.status === SUCCESS_RESULT) {
          cogoToast.success(response.data.message, { hideAfter: 5 });
          listPayrollDetails();
          listTracks();
          setshowModal(false);
        } else {
          cogoToast.error(response.data.message, { hideAfter: 5 });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
        cogoToast.error("Something went wrong, please Try again. " + err, { hideAfter: 5 });
      });
  };

  const formatCurrency = (value) => (
    <NumericFormat value={value} displayType={'text'} thousandSeparator={true} prefix={'$'} />
  );

  const payrollData = {
    payrollAmountk: 5000,
    taxes: 800,
    gratuity: 150,
    allowances: 300,
    bonuses: 450,
  };

  return (
    <Container fluid className="p-4 bg-light min-vh-100">
      <Loader loading={isLoading} />

      {/* Header Section */}
      <Row className="mb-4">
        <Col md={10}>
          <h1 className="text-dark font-weight-bold">Completed Payroll Details</h1>
        </Col>
      </Row>

      {/* Filter Section */}
      <Row className="mb-4">
        <Col md={4}>
          <Label for="trackSelect">Select Track</Label>
          <Input type="select" id="trackSelect" value={selected_track_id} onChange={(e) => setSelected_track_id(e.target.value)}>
            <option value="">Select Track</option>
            {payroll_tracks.map((track) => <option key={track.id} value={track.id}>{track.name}</option>)}
          </Input>
        </Col>
        <Col md={4}>
          <Label for="statusSelect">Select Payroll Status</Label>
          <Input type="select" id="statusSelect" value={status} onChange={(e) => setstatus(e.target.value)}>
            <option value="">Select Status</option>
            <option value={10003}>DRAFT</option>
            <option value={10001}>COMPLETED</option>
          </Input>
        </Col>
        <Col md={2}>
          <Button color="primary" onClick={listPayrollDetails} className="w-100 mt-4">View</Button>
        </Col>
         <Col md={2}>
          <Button color="primary" onClick={() =>alert("The engine is under maintenance. Please try again later")} className="w-120 mt-4">EXPORT PAYROLL TO EXCEL</Button>
        </Col>
           {/* <Row>
        <Col md={12}>
          <button type="button" onClick={() =>alert("The engine is under maintenance. Please try again later")} class="btn btn-success text-end float-end">
          <FaFileDownload className="me-2" />
          EXPORT PAYROLL TO EXCEL
        </button>
        </Col>
      
      </Row> */}
      </Row>
   
      {/* Payroll Metrics Cards */}
      {/* <Row className="mb-4">
        <Col md={2} className="text-center">
          <Card className="shadow-sm hover-shadow">
            <Card.Body>
              <i className="fa fa-users fa-3x text-primary"></i>
              <h5 className="mt-2">Employees</h5>
              <h4>{payrollData.payrollAmount ?? 0}</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} className="text-center">
          <Card className="shadow-sm hover-shadow">
            <Card.Body>
              <i className="fa fa-dollar-sign fa-3x text-success"></i>
              <h5 className="mt-2">Payroll Amount</h5>
              <h4>{formatCurrency(payrollData.payrollAmount ?? 0)}</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} className="text-center">
          <Card className="shadow-sm hover-shadow">
            <Card.Body>
              <i className="fa fa-file-invoice-dollar fa-3x text-danger"></i>
              <h5 className="mt-2">Taxes</h5>
              <h4>{formatCurrency(payrollData.taxes)}</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} className="text-center">
          <Card className="shadow-sm hover-shadow">
            <Card.Body>
              <i className="fa fa-gift fa-3x text-info"></i>
              <h5 className="mt-2">Gratuity</h5>
              <h4>{formatCurrency(payrollData.gratuity)}</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} className="text-center">
          <Card className="shadow-sm hover-shadow">
            <Card.Body>
              <i className="fa fa-briefcase fa-3x text-warning"></i>
              <h5 className="mt-2">Allowances</h5>
              <h4>{formatCurrency(payrollData.allowances)}</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} className="text-center">
          <Card className="shadow-sm hover-shadow">
            <Card.Body>
              <i className="fa fa-trophy fa-3x text-secondary"></i>
              <h5 className="mt-2">Bonuses</h5>
              <h4>{formatCurrency(payrollData.bonuses)}</h4>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}

      {/* AG Grid Table */}
      <div className="ag-theme-alpine" style={{ width: "100%", height: "400px" }}>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {

              headerName: "Staff Name",
              field: "staff_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Designation",
              field: "role_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Sector ",
              field: "sector",
              sortable: true,
              filter: true,
            },

            {
              headerName: "Office ",
              field: "office_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Hours worked ",
              field: "hrs_worked",
              sortable: true,
              filter: true,
            }, {
              headerName: "leave hrs ",
              field: "total_leave_hrs",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Basic salary ",
              field: "basic_salary",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Total allowances ",
              field: "total_allowances",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Gratuity ",
              field: "gratuity",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Taxes ",
              field: "taxes",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Net Pay ",
              field: "net_pay",
              sortable: true,
              filter: true,
            },
          ]}
          defaultColDef={{ flex: 1, minWidth: 100, filter: true, resizable: true }}
          pagination
        />
      </div>

      {/* Floating Action Button */}
      <Fab
        icon={<i className="fa fa-save"></i>}
        event={null}
        alwaysShowTitle={true}
        onClick={() => setshowModal(true)}
        text="Save Payroll"
      />
    </Container>
  );
};

export default CompletedPayroll;
